import { BarRightContainer } from './bar-right.styles';

const BarRight = () => (
    <BarRightContainer></BarRightContainer>
);

export default BarRight;